export enum RoutesEnum {
  TitreRestoRoute = 'company/titre-restaurant',
  ChequeCadeauRoute = 'company/cheque-cadeau',
  ChequeVacanceRoute = 'company/cheque-vacances',
  BonsEssenceRoute = 'company/bon-essence',
  ProfilRoute = 'company/profil',
  AideRoute = 'company/aide',
  ProfilRouteMerchant = 'merchant/profil',
  SoldeRoute = 'company/solde',
  TransactionRouteM = 'merchant/transactions',
  QrCodeRouteM = 'merchant/qr-code',
  SoldeRouteM = 'merchant/solde',
  AideRouteM = 'merchant/aide',
  signinRoute = 'company/signin',
  signinRouteM = 'merchant/signin',
  signinupRoute = 'company/signup',
  signinupRouteM = 'merchant/signup',
  kidsRouteM = 'merchant/kids',
   BonsRouteM = 'merchant/bons',
  activateRouteCompany = 'company/activate',
 // firstLoginChangePassword = 'first-login-change-password',
  activateRouteMerchant = 'merchant/activate',
  notFoundRoute = 'not-found',
  TR = 'Titres restaurant',
  CC = 'Chèque cadeau entreprise',
  CV = 'Chèques vacances',
  BE = "Bon essence",
}
